<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-8 inline">
          <h4>
            <h2 style="display: inline">Analytics | &nbsp;</h2>
            Select Time:
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.selectTime"
              @change="getData()"
            >
              <el-option
                v-for="option in selects.timeSeries"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
          <h4>
            Select Site:
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="filter.site"
              @change="getData()"
            >
              <el-option
                v-for="option in filter.sites"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
        <div class="col-lg-4 style-date">
          <span class="demonstration">Select Date Range</span>
          <el-date-picker
            v-model="selectDate"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            @change="getData()"
          ></el-date-picker>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 d-flex">
          <card>
            <template slot="header">
              <h5 class="card-category">
                <!-- <b>Weekly</b> -->
              </h5>
              <h3 class="card-title">
                <i class="tim-icons icon-paper text-info"></i>
                <b>&nbsp;Top 5 Work Order by Location</b>
              </h3>
            </template>
            <div class="row">
              <div class="col-lg">
                <el-table
                  :data="top5location"
                  :header-cell-style="{
                    background: 'transparent',
                    border: 'none',
                    borderBottom: '0.5px solid #3d3f51',
                  }"
                  :cell-style="{
                    border: 'none',
                    borderBottom: '0.5px solid #3d3f51',
                  }"
                  :height="300"
                >
                  <el-table-column
                    label="Location"
                    prop="location"
                  ></el-table-column>
                  <el-table-column
                    label="Total Work Order"
                    prop="totalworkorder"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-9 d-flex">
          <!-- work status graph -->
          <card>
            <template slot="header">
              <h5 class="card-category">
                <!-- <b>Weekly</b> -->
              </h5>
              <h3 class="card-title">
                <i class="tim-icons icon-chart-bar-32 text-info"></i>
                <b
                  >&nbsp;Work Status Graph for Preventive vs Non-preventive
                  Maintenance</b
                >
              </h3>
            </template>
            <div class="chart-area">
              <line-chart
                v-if="workstatus.loaded"
                :chart-data="workstatus.chartData"
                :gradient-colors="workstatus.gradientColors"
                :gradient-stops="workstatus.gradientStops"
                :extra-options="workstatus.extraOptions"
                :height="300"
              ></line-chart>

              <div
                class="d-flex justify-content-center spinner"
                v-if="!workstatus.loaded"
              >
                <circle-8></circle-8>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 d-flex">
          <card>
            <template slot="header">
              <h5 class="card-category">
                <!-- <b>Weekly</b> -->
              </h5>
              <h3 class="card-title">
                <i class="tim-icons icon-paper text-info"></i>
                <b>&nbsp;Top 5 Work Order by Asset</b>
              </h3>
            </template>
            <div class="row">
              <div class="col-lg">
                <el-table
                  :data="top5asset"
                  :header-cell-style="{
                    background: 'transparent',
                    border: 'none',
                    borderBottom: '0.5px solid #3d3f51',
                  }"
                  :cell-style="{
                    border: 'none',
                    borderBottom: '0.5px solid #3d3f51',
                  }"
                  :height="300"
                >
                  <el-table-column label="Asset" prop="asset"></el-table-column>
                  <el-table-column
                    label="Total Work Order"
                    prop="totalworkorder"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg d-flex">
          <!-- work order against work type -->
          <card>
            <template slot="header">
              <h5 class="card-category">
                <!-- <b>Weekly</b> -->
              </h5>
              <h3 class="card-title">
                <i class="tim-icons icon-chart-bar-32 text-info"></i>
                <b>&nbsp;Total Work Order Against Work Type</b>
              </h3>
            </template>
            <div class="chart-area">
              <bar-chart
                v-if="workorderagainstworktype.loaded"
                :chart-data="workorderagainstworktype.chartData"
                :gradient-colors="workorderagainstworktype.gradientColors"
                :gradient-stops="workorderagainstworktype.gradientStops"
                :extra-options="workorderagainstworktype.extraOptions"
                :height="300"
              ></bar-chart>
              <div
                class="d-flex justify-content-center spinner"
                v-if="!workorderagainstworktype.loaded"
              >
                <circle-8></circle-8>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg d-flex">
          <card>
            <template slot="header">
              <h5 class="card-category">
                <!-- <b>Weekly</b> -->
              </h5>
              <h3 class="card-title">
                <i class="tim-icons icon-chart-bar-32 text-info"></i>
                <b>&nbsp;Total Work Order Against Work Trade</b>
              </h3>
            </template>
            <div class="chart-area">
              <bar-chart
                v-if="workorderagainstworktrade.loaded"
                :chart-data="workorderagainstworktrade.chartData"
                :gradient-colors="workorderagainstworktrade.gradientColors"
                :gradient-stops="workorderagainstworktrade.gradientStops"
                :extra-options="workorderagainstworktrade.extraOptions"
                :height="300"
              ></bar-chart>
              <div
                class="d-flex justify-content-center spinner"
                v-if="!workorderagainstworktrade.loaded"
              >
                <circle-8></circle-8>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import { Select, Option, DatePicker, Table, TableColumn } from "element-ui";

import axios from "axios";
import moment from "moment";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import { time } from "d3";

export default {
  components: {
    LineChart,
    BarChart,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Circle8,
  },
  data() {
    return {
      // Selecting interval data
      filter: {
        site: "",
        sites: [],
      },
      selects: {
        selectCustomer: "",
        selectRegion: "",
        selectRoute: "",
        selectDriver: "",
        selectTime: "",
        timeSeries: [
          { value: "today", label: "Today" },
          // { value: "weekly", label: "Weekly" },
          { value: "monthly", label: "Monthly" },
          { value: "yearly", label: "Yearly" },
        ],
        customer: [{ value: "All", label: "All" }],
        region: [{ value: "All", label: "All" }],
        route: [{ value: "All", label: "All" }],
        driver: [{ value: "All", label: "All" }],
      },

      disableRegion: true,
      disableRoute: true,
      disableDriver: true,
      selectDate: "",
      customerLogs: null,
      regionLogs: null,
      routeLogs: null,
      driverLogs: null,
      custPunctuality: null,
      regionPunctuality: null,
      routePunctuality: null,
      driverPunctuality: null,
      labels: null,
      // Two Line Chart
      workstatus: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "Preventive",
              fill: true,
              borderColor: "rgba(37, 67, 117, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(37, 67, 117, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [150, 150, 150, 150, 150, 150, 150],
            },
            {
              label: "Non-preventive",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(255, 3, 2, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [110, 130, 90, 98, 105, 110, 130],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(37, 67, 117, 0.5)",
          "rgba(37, 67, 117, 0.0)",
          "rgba(37, 67, 117, 0.0)",
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.0)",
        ],
        gradientStops: [1, 0.4, 0, 1, 0.4, 0],
        loaded: true,
      },
      workorderagainstworktype: {
        chartData: {
          labels: [
            "Work Type 1",
            "Work Type 2",
            "Work Type 3",
            "Work Type 4",
            "Work Type 5",
            "Work Type 6",
            "Work Type 7",
          ],
      
          datasets: [
            {
              label: "Breakdown",
              fill: true,
              borderColor: "#641E16",
              backgroundColor: "#641E16",

              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Corrective",
              fill: true,
              borderColor: "#512E5F",
              backgroundColor: "#512E5F",

              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Feedback",
              fill: true,
              borderColor: "#154360",
              backgroundColor: "#154360",

              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Inspection",
              fill: true,
              borderColor: "#0E6251",
              backgroundColor: "#0E6251",

              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Manual Preventive",
              fill: true,
              borderColor: "#145A32",
              backgroundColor: "#145A32",

              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Predictive",
              fill: true,
              borderColor: "#7D6608",
              backgroundColor: "#7D6608",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Preventive",
              fill: true,
              borderColor: "#784212",
              backgroundColor: "#784212",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Project",
              fill: true,
              backgroundColor: "#7B7D7D",
              borderColor: "#7B7D7D",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Reimbursable",
              fill: true,
              borderColor: "#1B2631",
              backgroundColor: "#1B2631",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },
      workorderagainstworktrade: {
        chartData: {
          labels: [
            "Work Trade 1",
            "Work Trade 2",
            "Work Trade 3",
            "Work Trade 4",
            "Work Trade 5",
            "Work Trade 6",
            "Work Trade 7",
          ],

          datasets: [
            {
              label: "Civil Structure",
              fill: true,
              borderColor: "#641E16",
              backgroundColor: "#641E16",

              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Electrical",
              fill: true,
              borderColor: "#512E5F",
              backgroundColor: "#512E5F",

              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Housekeeping",
              fill: true,
              borderColor: "#154360",
              backgroundColor: "#154360",

              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Ict",
              fill: true,
              borderColor: "#0E6251",
              backgroundColor: "#0E6251",

              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Landscape",
              fill: true,
              borderColor: "#145A32",
              backgroundColor: "#145A32",

              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Mechanical",
              fill: true,
              borderColor: "#7D6608",
              backgroundColor: "#7D6608",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Safety",
              fill: true,
              borderColor: "#784212",
              backgroundColor: "#784212",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },
      top5location: [
        {
          location: "Location A",
          totalworkorder: "10",
        },
        {
          location: "Location B",
          totalworkorder: "5",
        },
        {
          location: "Location C",
          totalworkorder: "4",
        },
        {
          location: "Location D",
          totalworkorder: "3",
        },
        {
          location: "Location E",
          totalworkorder: "1",
        },
      ],
      top5asset: [
        {
          asset: "Asset A",
          totalworkorder: "15",
        },
        {
          asset: "Asset B",
          totalworkorder: "11",
        },
        {
          asset: "Asset B",
          totalworkorder: "8",
        },
        {
          asset: "Asset B",
          totalworkorder: "7",
        },
        {
          asset: "Asset B",
          totalworkorder: "3",
        },
      ],
      performancePercentage: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "%Number of Pickup",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },
      barChart2: {
        chartData: {
          labels: ["1 Star", "2 Star", "3 Star", "4 Star", "5 Star"],
          datasets: [
            {
              label: "Rating",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [1, 2, 3, 4, 5],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.barChartOptionsGradient,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },

      // customer rating
      rating: [],
      // punctuality
      punctuality: [],
    };
  },
  methods: {
    getSite() {
      this.filter.sites = [];

      this.$http.get(":9998/api/v1/setting/site").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].SiteName,
              value: response[i].SiteCode,
            };
            this.filter.sites.push(obj);
          }

          this.filter.site = this.filter.sites[0].value;
          this.getData();
        }
      });
    },
    getWorkOrderByLocation() {
      this.top5location = [];
      let start = moment(this.selectDate[0]).format("YYYY-MM-DD");
      let end = moment(this.selectDate[1]).format("YYYY-MM-DD");
      // let start = "2022-08-01";
      // let end = "2022-08-10";
      this.$http
        .get(
          ":9998/api/v1/analytics/graph/workorders/location?from=" +
            start +
            "&to=" +
            end
        )
        // this.$http.get(":9998/api/v1/analytics/graph/workstatus?interval=" + this.selects.selectTime +"&from="+ moment(this.selectDate[0]).format('YYYY-MM-DD') + "&to=" + moment(this.selectDate[1]).format('YYYY-MM-DD')).
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            for (var i = 0; i < response.length; i++) {
              let obj = {
                location: response[i].LocationName,
                totalworkorder: response[i].WorkorderCount,
              };
              this.top5location.push(obj);
            }
          }
        });
    },
    async getWorkStatusGraph(flag) {
      console.log(this.selects.selectTime);
      console.log(flag);
      let start = moment(this.selectDate[0]).format("YYYY-MM-DD");
      let end = moment(this.selectDate[1]).format("YYYY-MM-DD");
      // let start = "2022-08-01";
      // let end = "2022-08-05";
      console.log(start, end);
      // this.$http.get(":9998/api/v1/analytics/graph/workstatus?interval=today&from=2022-08-01&to=2022-08-05&worktype=preventive").
      await this.$http
        .get(
          ":9998/api/v1/analytics/graph/workstatus?interval=" +
            this.selects.selectTime +
            "&from=" +
            start +
            "&to=" +
            end +
            "&worktype=" +
            flag
          // "&site-id=" +
          // this.filter.site
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(flag);
            let preventive = [];
            let nonpreventive = [];

            let timestamp1 = [];
            let timestamp2 = [];
            if (flag == "preventive") {
              console.log(response);
              for (var i = 0; i < response.length; i++) {
                preventive.push(
                  response[i].Open +
                    response[i].Closed +
                    response[i].Cancelled +
                    response[i].Completed +
                    response[i].Incomplete
                );
                timestamp1.push(response[i].Duration);
              }
            }

            if (flag == "") {
              console.log(response);
              for (var i = 0; i < response.length; i++) {
                nonpreventive.push(
                  response[i].Open +
                    response[i].Closed +
                    response[i].Cancelled +
                    response[i].Completed +
                    response[i].Incomplete
                );
                timestamp2.push(response[i].Duration);
              }
            }
            let a = [];
            let b = [];
            let timestamp = [];
            if (timestamp1.length >= timestamp2.length) {
              a = timestamp1;
              b = timestamp2;
            }

            if (timestamp2.length > timestamp1.length) {
              a = timestamp2;
              b = timestamp1;
            }
            console.log(a);
            console.log(b);
            for (var i = 0; i < a.length; i++) {
              console.log(a[i]);
              for (var e = 0; e < b.length; e++) {
                console.log(b[e]);
                if (a[i] == b[e]) {
                  timestamp.push(a[i]);
                }
              }

              if (b.length == 0) {
                timestamp.push(a[i]);
              }
            }

            console.log(timestamp);
            console.log(preventive);
            console.log(nonpreventive);

            this.workstatus = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    label: "Preventive",
                    fill: true,
                    borderColor: "rgba(37, 67, 117, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgba(37, 67, 117, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: preventive,
                  },
                  {
                    label: "Non-preventive",
                    fill: true,
                    borderColor: "rgba(255, 3, 2, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgba(255, 3, 2, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: nonpreventive,
                  },
                ],
              },
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(37, 67, 117, 0.5)",
                "rgba(37, 67, 117, 0.0)",
                "rgba(37, 67, 117, 0.0)",
                "rgba(255, 3, 2, 0.8)",
                "rgba(255, 3, 2, 0.2)",
                "rgba(255, 3, 2, 0.0)",
              ],
              gradientStops: [1, 0.4, 0, 1, 0.4, 0],
              loaded: true,
            };
          }
        });
    },
    getData() {
      this.getWorkOrderByLocation();
      this.getWorkStatusGraph("preventive");
      this.getWorkStatusGraph("");
      this.getWorkOrderByAsset();
      this.getTotalWorkOrdervsWorkType();
      this.getTotalWorkOrdervsWorkTrade();
    },
    getWorkOrderByAsset() {
      this.top5asset = [];
      console.log(this.filter.site);
      console.log(this.selects.selectTime);
      console.log(moment(this.selectDate[0]).format("YYYY-MM-DD"));
      console.log(moment(this.selectDate[1]).format("YYYY-MM-DD"));
      let start = moment(this.selectDate[0]).format("YYYY-MM-DD");
      let end = moment(this.selectDate[1]).format("YYYY-MM-DD");

      // let start = "2022-07-01"
      // let end = "2022-08-01"
      this.$http
        .get(
          ":9998/api/v1/analytics/graph/workorders/asset?site-id=" +
            this.filter.site +
            "&from=" +
            start +
            "&to=" +
            end
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            for (var i = 0; i < response.length; i++) {
              let obj = {
                asset: response[i].AssetDescription,
                totalworkorder: response[i].WorkorderCount,
              };
              this.top5asset.push(obj);
            }
          }
        });
    },
    async getTotalWorkOrdervsWorkType() {
      this.workorderagainstworktype.loaded = false
      this.workorderagainstworktrade.loaded = false
      let start = moment(this.selectDate[0]).format("YYYY-MM-DD");
      let end = moment(this.selectDate[1]).format("YYYY-MM-DD");

      // let start = "2022-07-01"
      // let end = "2022-08-01"
      await this.$http
        .get(
          ":9998/api/v1/analytics/graph/worktype?from=" + start + "&to=" + end
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            // let data = [];
            let timestamp = [];
            let breakdown = [];
            let corrective = [];
            let feedback = [];
            let inspection = [];
            let manualpreventive = [];
            let predictive = [];
            let preventive = [];
            let project = [];
            let reimbursable = [];
            for (var i = 0; i < response.length; i++) {
              breakdown.push(response[i].Breakddown);
              corrective.push(response[i].Corrective);
              feedback.push(response[i].Feedback);
              inspection.push(response[i].Inspection);
              manualpreventive.push(response[i].ManualPreventive);
              predictive.push(response[i].Predictive);
              preventive.push(response[i].Preventive);
              project.push(response[i].Project);
              reimbursable.push(response[i].Reimbursable);
              timestamp.push(response[i].Duration);
            }
            this.workorderagainstworktype = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    label: "Breakdown",
                    fill: true,
                    borderColor: "#641E16",
                    backgroundColor: "#641E16",

                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: breakdown,
                  },
                  {
                    label: "Corrective",
                    fill: true,
                    borderColor: "#512E5F",
                    backgroundColor: "#512E5F",

                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: corrective,
                  },
                  {
                    label: "Feedback",
                    fill: true,
                    borderColor: "#154360",
                    backgroundColor: "#154360",

                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: feedback,
                  },
                  {
                    label: "Inspection",
                    fill: true,
                    borderColor: "#0E6251",
                    backgroundColor: "#0E6251",

                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: inspection,
                  },
                  {
                    label: "Manual Preventive",
                    fill: true,
                    borderColor: "#145A32",
                    backgroundColor: "#145A32",

                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: manualpreventive,
                  },
                  {
                    label: "Predictive",
                    fill: true,
                    borderColor: "#7D6608",
                    backgroundColor: "#7D6608",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: predictive,
                  },
                  {
                    label: "Preventive",
                    fill: true,
                    borderColor: "#784212",
                    backgroundColor: "#784212",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: predictive,
                  },
                  {
                    label: "Project",
                    fill: true,
                    backgroundColor: "#7B7D7D",
                    borderColor: "#7B7D7D",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: project,
                  },
                  {
                    label: "Reimbursable",
                    fill: true,
                    borderColor: "#1B2631",
                    backgroundColor: "#1B2631",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: reimbursable,
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.percentageBarChart,
              gradientColors: [
                "rgba(255, 3, 2, 0.8)",
                "rgba(255, 3, 2, 0.2)",
                "rgba(255, 3, 2, 0.1)",
              ],
              gradientStops: [1, 0],
            };
          }
        });
    },
    async getTotalWorkOrdervsWorkTrade() {
      let start = moment(this.selectDate[0]).format("YYYY-MM-DD");
      let end = moment(this.selectDate[1]).format("YYYY-MM-DD");

      // let start = "2022-08-01"
      // let end = "2022-09-01"
      await this.$http
        .get(
          ":9998/api/v1/analytics/graph/worktrade?from=" + start + "&to=" + end
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            let civilstructure = [];
            let electrical = [];
            let housekeeping = [];
            let ict = [];
            let landscape = [];
            let mechanical = [];
            let safety = [];
            let timestamp = [];

            for (var i = 0; i < response.length; i++) {
              timestamp.push(response[i].Duration);
              civilstructure.push(response[i].CivilStructure);
              electrical.push(response[i].Electrical);
              housekeeping.push(response[i].Housekeeping);
              ict.push(response[i].Ict);
              landscape.push(response[i].Landscape);
              mechanical.push(response[i].Mechanical);
              safety.push(response[i].Safety);
            }

            this.workorderagainstworktrade = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    label: "Civil Structure",
                    fill: true,
                    borderColor: "#641E16",
                    backgroundColor: "#641E16",

                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: civilstructure,
                  },
                  {
                    label: "Electrical",
                    fill: true,
                    borderColor: "#512E5F",
                    backgroundColor: "#512E5F",

                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: electrical,
                  },
                  {
                    label: "Housekeeping",
                    fill: true,
                    borderColor: "#154360",
                    backgroundColor: "#154360",

                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: housekeeping,
                  },
                  {
                    label: "Ict",
                    fill: true,
                    borderColor: "#0E6251",
                    backgroundColor: "#0E6251",

                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: ict,
                  },
                  {
                    label: "Landscape",
                    fill: true,
                    borderColor: "#145A32",
                    backgroundColor: "#145A32",

                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: landscape,
                  },
                  {
                    label: "Mechanical",
                    fill: true,
                    borderColor: "#7D6608",
                    backgroundColor: "#7D6608",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: mechanical,
                  },
                  {
                    label: "Safety",
                    fill: true,
                    borderColor: "#784212",
                    backgroundColor: "#784212",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: safety,
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.percentageBarChart,
              gradientColors: [
                "rgba(255, 3, 2, 0.8)",
                "rgba(255, 3, 2, 0.2)",
                "rgba(255, 3, 2, 0.1)",
              ],
              gradientStops: [1, 0],
            };
          }
        });
    },
  },

  created() {
    this.getSite();
    this.selectDate = [moment().startOf("isoWeek"), moment().endOf("isoWeek")];
    this.selects.selectTime = this.selects.timeSeries[0].value;
    // this.getWorkOrderByLocation();
    // this.getWorkStatusGraph("preventive");
    // this.getWorkStatusGraph("");
    // this.getWorkOrderByAsset();
    // this.getTotalWorkOrdervsWorkType();
    // this.getTotalWorkOrdervsWorkTrade();
  },
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
}
hr {
  color: black;
  margin-top: 0%;
}
.select-width {
  max-width: 50%;
}
.spinner {
  margin: 12%;
}
</style>
